import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import type { Guest } from "@/types/camping";

/** Gast per ID laden, wenn er nicht in der optionalen Cache-Liste steht (z. B. erste 200 aus Listen-API). */
export function useGuestById(
  guestId: string | null | undefined,
  cachedGuests?: Guest[],
): Guest | null {
  const cached =
    guestId && cachedGuests
      ? (cachedGuests.find((g) => g.id === guestId) ?? null)
      : null;

  const [fetched, setFetched] = useState<Guest | null>(null);

  useEffect(() => {
    if (!guestId || cached) {
      setFetched(null);
      return;
    }
    let cancelled = false;
    void api
      .get<Guest>(`/api/v1/guests/${guestId}`)
      .then((guest) => {
        if (!cancelled) setFetched(guest);
      })
      .catch(() => {
        if (!cancelled) setFetched(null);
      });
    return () => {
      cancelled = true;
    };
  }, [guestId, cached]);

  return cached ?? fetched;
}
